var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000003",
    fillRule: "evenodd",
    d: "M16 3.243H8a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h8a5 5 0 0 0 5-5v-8a5 5 0 0 0-5-5m3.25 13a3.26 3.26 0 0 1-3.25 3.25H8a3.26 3.26 0 0 1-3.25-3.25v-8A3.26 3.26 0 0 1 8 4.993h8a3.26 3.26 0 0 1 3.25 3.25zm-2.5-7.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 7.743a4.5 4.5 0 1 0 4.5 4.5 4.49 4.49 0 0 0-4.5-4.5m-2.75 4.5a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgInstagram;